import type { EncoderDevice, ResolvedEncoderDevice } from "./types";
import onnxRuntimeWasmUrl from "../../node_modules/onnxruntime-web/dist/ort-wasm-simd-threaded.jsep.wasm?url";

export type OnnxRuntimePlan = {
  device: ResolvedEncoderDevice;
  /** Zero delegates thread selection to ONNX Runtime. */
  wasmThreads: number;
};

/** The ONNX JavaScript glue is bundled into the semantic worker. Keep its
 * external WASM binary same-origin so model startup has no CDN dependency. */
export const ONNX_RUNTIME_WASM_PATHS = {
  wasm: onnxRuntimeWasmUrl,
};

/**
 * ONNX Runtime's WebGPU execution provider uses its JSEP WASM core for session
 * setup. Letting that control runtime create a pthread pool can deadlock session
 * construction on Apple Silicon even though adapter and device creation work.
 * WebGPU does the model compute, so its control runtime gains nothing from that
 * pool. A real WASM execution provider still gets ONNX Runtime's automatic,
 * cross-origin-isolated thread selection.
 */
export function onnxRuntimeThreadCount(device: ResolvedEncoderDevice) {
  return device === "webgpu" ? 1 : 0;
}

export function onnxRuntimePlan(device: EncoderDevice): OnnxRuntimePlan[] {
  const webgpu = { device: "webgpu", wasmThreads: 1 } as const;
  const wasmAuto = { device: "wasm", wasmThreads: 0 } as const;
  const wasmSingle = { device: "wasm", wasmThreads: 1 } as const;
  if (device === "webgpu") return [webgpu];
  if (device === "wasm") return [wasmAuto, wasmSingle];
  return [webgpu, wasmAuto, wasmSingle];
}
